<template>
    <img :src="headerImgUrl">
</template>

<script>
    import {storage} from '../main';

    export default {
        name: 'FireImage',
        created: function () {
            this.getImgUrl(this.$props.refName)
        },
        props: ['refName'],
        data() {
            return {
                headerImgUrl: null
            }
        },
        methods: {
            getImgUrl: function (imgName) {
                const _this = this;
                storage.ref(imgName).getDownloadURL().then(url => {
                    _this.headerImgUrl = url
                })
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/FireImage.vue